import moment from 'moment';
import CookieHandler from './cookie_handler'
import ParamHeadler from './param_handler'

import { ActivityFormEventHandler, ActivityFormEvents } from '../../process/events/activity_form_event_handler';

const LOCALE_MAPPING = {
	'pt_BR': 'pt-BR',
	'en_US': 'en',
	'es_ES': 'es'
};

export function setLocale(){
	let userLanguage = ParamHeadler.getLanguage();
	if(!userLanguage)
		userLanguage = CookieHandler.getLanguage();
	let locale = LOCALE_MAPPING[userLanguage] || 'pt-BR';
	Realize.i18n.setLocale(locale);
}

export function setMoment(){
	const currentLocale = Realize.i18n.currentLocale.toLowerCase();
	moment.locale(currentLocale);
}

export function loadLocale(){
	setLocale();
	setMoment();
}

loadLocale();
// ActivityFormEventHandler.subscribe(ActivityFormEvents.LOAD_PROCESS_STORE_PROPS, loadLocale);
